import React, { createContext, useContext, useState } from "react";

const BillingContext = createContext();

export const BillingProvider = ({ children }) => {
	const [bills, setBills] = useState([]);

	const addBill = (bill) => {
		setBills((prev) => [bill, ...prev]);
	};

	const setAllBills = (data) => {
		setBills(data);
	};

    const removeBill = (billingId) => {
        setBills((prev) => prev.filter((b) => {
            const bill = b.billingRes || b;
            return bill.billingid !== billingId;
        }));
    };

	return (
		<BillingContext.Provider value={{ bills, addBill, setAllBills ,removeBill }}>
			{children}
		</BillingContext.Provider>
	);
};

export const useBilling = () => useContext(BillingContext);